module.exports = __webpack_public_path__ + "static/media/icons_Bilan Lésion musculaire.c2eb1084.svg";